// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"e9236f4a","498":"4a26c39e","703":"b208611d"}[chunkId] + ".chunk.js";
};